/* eslint-disable */
import { useState } from 'react';
import { useForm } from "react-hook-form";
import axios from 'axios';

export default function WaMessage({ event, setNodes, wa_authKey, setRefecther, refecther }) {

    const [refresher, setRefresher] = useState(false);
    const [msgType, setMsgType] = useState(event.data.value.api.msg_type || "");
    const [fileInfo, setFileInfo] = useState(null);
    const [filePath, setFilePath] = useState("");
    const [fileStatus, setFileStatus] = useState(0)
    const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm({ defaultValues: event.data.value.api });


    const waMsgSet = (value) => {
        setNodes(nds => nds.map(node => {
            if (node.id == event.id) {
                node.data.value.api.data = value;
            }
            return node;
        }));
        setRefecther(!refecther);
        setRefresher(!refresher);
    };
    const onFileChange = (e) => {
        const file = e.target.files[0];
        console.log(e.target.files)
        if (!file) return;
        setValue("file", file, { shouldValidate: true });
        waMsgSet(file);
        setFileInfo({name: file.name,size: (file.size / 1024).toFixed(2)});
    };
    const chgMsgType = (val) => {
        setNodes(nds => nds.map(node => {
            if (node.id == event.id) {
                node.data.value.api = {
                    msg_type: val,
                    data: "",
                    auth_key: wa_authKey
                };
            }
            return node;
        }));

        setMsgType(val);
        setRefecther(!refecther);
        setRefresher(!refresher);
    };
    const onSubmit = async (data) => {
        const formData = new FormData();
        formData.append("file", data.file); // file

        try {
            const res = await axios.post("https://oiomni.com/api/file_Save", formData, {headers: { "Content-Type": "multipart/form-data" }});
            if(res.data.status == "200"){
                setFileStatus(1)
                setFileInfo("")

                setNodes(nds => nds.map(node => {
                    if (node.id == event.id) {
                        node.data.value.api.data = res.data.file_path;
                    }
                    return node;
                }));
                setFilePath(res.data.file_path)
                setRefecther(!refecther);
                setRefresher(!refresher);
            }
        } catch (error) {
            console.error("Upload error", error);
        }
    };

    const MsgBody = ({ messageType }) => {
        if (!messageType) return null;

        if (messageType === "text") {
            return (
                <div className="body_enter_text_box mb-2">
                    <textarea
                        {...register("data", { required: "Please add the text" })}
                        className="form-control"
                        placeholder="Enter Message"
                        defaultValue={event.data.value.api.data}
                        onBlur={(e) => waMsgSet(e.target.value)}
                    ></textarea>
                </div>
            );
        }

        if (messageType === "file") {
            return (
                <div className="body_enter_text_box mb-2">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <input type="file" id="file" {...register("file")} onChange={onFileChange} />

                        {fileInfo && (
                                <div className="mt-2">
                                <p><b>File Name:</b> {fileInfo.name}</p>
                                <p><b>File Name:</b> {fileInfo.size}</p>
                                </div>
                        )

                        }
                        <button class="bg-sky-50" type="submit">Add</button>
                    </form>
                </div>
            );
        }

        return null;
    };

    const Filestatus = () => {
        if (filePath && filePath != ""){
            return (
                <div className="mt-2">
                    <p><b>File Name:</b> {filePath}</p>
                </div>
            )
        }
    }

    return (
        <div className="card-body mt-0 ">
            <div className="contact_add_div">
                <div className="mx-auto">
                    <div className="body_teml mt-2">
                        <label className="header_heading">
                            <i className="fa-solid fa-file-lines"></i> Body
                        </label>

                        <select className="form-select mb-2" {...register("msg_type", {required: true,onChange: (e) => chgMsgType(e.target.value),})} defaultValue={msgType}>
                            <option value="">Select the media Type</option>
                            <option value="file">File</option>
                            <option value="text">Text</option>
                        </select>
                        <Filestatus />
                        <MsgBody messageType={event.data.value.api.msg_type} />
                    </div>
                </div>
            </div>
        </div>
    );
}
